import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Users from '../pages/Users'
import EditUser from '../pages/EditUser'
import Tools from '../pages/Tools'
import Login from '../pages/Login'
import Home from '../pages/Home'
import NotFound from '../pages/NotFound'
import Tool from "../pages/Tool";
import EditTool from "../pages/EditTool";

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/domov',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uporabniki',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uporabnik/:id?',
      name: 'EditUser',
      component: EditUser,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orodja/:categoryId?',
      name: 'Tools',
      component: Tools,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orodje/:id',
      name: 'Tool',
      component: Tool,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uredi-orodje/:id?',
      name: 'EditTool',
      component: EditTool,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  let userTokeName =  sessionStorage.getItem("HRAM_user") ? JSON.parse(sessionStorage.getItem("HRAM_user")).userTokeName : null;

  let currentUser =  userTokeName ? JSON.parse(sessionStorage.getItem("HRAM_user")).userTokeName : null;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  let isAdmin = sessionStorage.getItem("HRAM_user") ? JSON.parse(sessionStorage.getItem("HRAM_user")).administrator : false;

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (!requiresAuth && currentUser) {
    next('/orodja')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js